import React, {useEffect, useState} from "react";
import StyledNavbar from "./Navbar.styled";
import {Link} from "gatsby";
import StyledContainer from "../Common/Container.styled";
import StyledNavContent from "./NavContent.styled";

const Navbar = () => {

    const [navbarOpen, setNavbarOpen] = useState(false);
    const [scrolled100px, setScrolled100px] = useState(false);

    const handleNavbarOpen = () => {
        console.log(`In handleNavbarOpen navbarOpen= ${navbarOpen}`);
        // console.log(`In handleNavbarOpen navbarCollapseDivRef=${navbarCollapseDivRef.current.valueOf().getBoundingClientRect().height}`);
        setNavbarOpen(!navbarOpen)
    }

    const isScrolled100px = () => {
        return window.scrollY >= 100;
    }

    useEffect(() => {
        const handleWindowScroll = () => setScrolled100px(isScrolled100px());
        window.addEventListener("scroll", handleWindowScroll);
        return () => {
            window.removeEventListener("scroll", () => handleWindowScroll())
        }
    }, [scrolled100px]);

    return (
        <StyledNavbar scrolled100={scrolled100px ? "navbar-shrink" : ""}>
            <StyledContainer>
                <StyledNavContent>
                    <Link to="#top" className="nav_brand">
                        <h1 className="logo">Kevin Effertz</h1>
                    </Link>
                    <button className="menu-button" onClick={handleNavbarOpen}>
                        <div className={`nav_icon fa-solid ${navbarOpen ? "fa-close" : "fa-bars"}`}></div>
                    </button>
                    <nav className="nav_menu">
                        <ul className={`nav_list ${navbarOpen ? "show" : ""}`}>
                            <li className="nav_item">
                                <Link to="#about" className="nav_link" onClick={handleNavbarOpen}>About</Link>
                            </li>
                            <li className="nav_item">
                                <Link to="#experience" className="nav_link" onClick={handleNavbarOpen}>Experience</Link>
                            </li>
                            <li className="nav_item">
                                <Link to="#video" className="nav_link" onClick={handleNavbarOpen}>Video</Link>
                            </li>
                            <li className="nav_item">
                                <Link to="#skills" className="nav_link" onClick={handleNavbarOpen}>Skills</Link>
                            </li>
                            <li className="nav_item">
                                <Link to="#contact" className="nav_link" onClick={handleNavbarOpen}>Contact</Link>
                            </li>
                        </ul>
                    </nav>
                </StyledNavContent>
            </StyledContainer>
        </StyledNavbar>
    )
}

export default Navbar